<template >

  <nav class="navbar navbar-expand-lg align-content-center" > <!--/*isPremium() ? premiumBackgroundStyle : null */-->
    <div class="container-fluid"  >
      <div class="navbar-minimize" >
        <button
           :class="'btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block'"
          @click="minimizeSidebar"
        >
          <i 
            :class="$sidebar.isMinimized ? 'fa fa-ellipsis-v' : 'fa fa-bars'"
          ></i>
        </button>
      </div>
      <div>
      <a class="navbar-brand"
        style="display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
        <span v-if="isPremium()" style=" margin-right: 10px; margin-bottom: 5px">
          <img src="static/img/premium.png" v-b-modal="'modal-premium'" width="25"></span> <span
          :class="'navbar-brand'">{{ routeName }}</span></a>
      </div>      
      <b-modal class="modal fade" id="modal-premium" ref="modal" hide-footer  >
        <div class=" d-flex justify-content-center">
          <div class="flex-column">
            <h5>Embajador Diamante</h5>
            <div class="d-flex justify-content-center" style="height:80px">
              <img src="@/assets/premium.gif" height="80">
            </div>
          </div>
        </div>
        <div>
          <h5>¿Por qué yo?</h5>
          <p>Esta distinción no se compra, ni se solicita. Si la tienes es por que eres un cliente <strong>muy
              especial</strong> para Numier. Valoramos muchísimo la apuesta que hacéis por nosotros y apreciamos cada vez
            recomendáis Numier TPV. </p>
          <br>
          <h5>¿Qué beneficios tiene?</h5>
          <template v-if="idTecnicoAsignado() != 0">
            <div style="text-align: center;">
              <img :src="'https://www.numier.com/img/admins/'+photoTecnicoAsignado()+'.jpg'" style="width: 125px; height: 125px;border-radius:50%; object-fit: cover; object-position:center top;" class="mb-4" alt="Técnico asignado" />
              <h5><span style="font-weight: bold">Técnico responsable:</span> {{nameTecnicoAsignado()}}</h5>
            </div>
          </template>
          <ul>
            <template v-if="idTecnicoAsignado() == 0">
              <li>Tendrás <strong>un técnico asignado</strong> que conocerá tus negocios y sus peculiaridades.</li>
            </template>
            <li>Este técnico será el <strong>responsable del seguimiento de cualquier instalación o incidencia.</strong>
            </li>
            <li><strong>Prioridad de llamadas</strong> en las guardias.</li>
            <li>Acceso a <strong>formaciones y descuentos exclusivos.</strong></li>
            <li>Acciones de Marketing cruzado.</li>
          </ul>
          
        </div>
        <br>
      
        <div>
          <b-button class="mt-3" block @click="$bvModal.hide('modal-premium')">Entendido</b-button>
        </div>
      </b-modal>
      <router-link :to="{ name: 'soporte-online' }" v-if="!esSelfi">                        
        <div class="row" :style="needsUpdate && this.screen.width < 992 ? 'margin-right: 0px !important;' : ''"
        >
          <button
            type="button"
            class="navbar-toggler navbar-toggler-right"
            :class="{ toggled: $sidebar.showSidebar }"
            
            aria-controls="navigation-index"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <i
              :class="{ 'text-warning': numTicketPendientes > 0 }"
              class="nc-icon nc-bell-55"
              
              :title="
                numTicketPendientes > 0
                  ? $t('tienesTicketsPendientesDeCerrar')
                  : ''
              "
            ></i>
          </button>
          <div
            class="text-center mobile-noti-number"
            v-if="numTicketPendientes > 0 && this.screen.width < 992"
          >
            <sup class="notification" >
              {{ numTicketPendientes }}
            </sup>
          </div>
        </div>
      </router-link>

      <router-link :to="{ name: 'novedades' }" >
        <div class="row" v-if="!esSelfi">
          <button
            type="button"
            class="navbar-toggler navbar-toggler-right"
            :class="{ toggled: $sidebar.showSidebar}"
            aria-controls="navigation-index"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i
              :class="{ 'text-warning': $store.state.xNotificaciones }"
              class="nc-icon nc-notification-70"></i>
            
          </button>
          <div
            class="text-center mobile-noti-number"
            
            v-if="$store.state.xListNovedades > 0 && this.screen.width < 992"
          >
            <sup class="notification">
              {{ $store.state.xListNovedades }}
            </sup>
          </div>
        </div>
      </router-link>
      <button
        type="button"
        class="navbar-toggler navbar-toggler-right"
        :class="{ toggled: $sidebar.showSidebar,  }"
        aria-controls="navigation-index"
        aria-expanded="false"
        aria-label="Toggle navigation"
        @click="toggleSidebar"
      >

        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        
      </button>

      <div class="collapse navbar-collapse justify-content-end" >
      <!--<b-button   ESTE ES EL BOTON PARA SOLICITAR ACTUALIZACION DESDE EL ORDENADOR
        v-if="needsUpdate && this.screen.width > 992" 
        @click="informacionTicketsUpdateTPV()"
        style="background-color:transparent; border-color: #ff9900; color: #007bff;" 
        pill variant="outline-secondary">
        <b-icon icon="arrow-clockwise" aria-hidden="true"></b-icon>
        <small>Actualización disponible</small>
      </b-button>-->
        
        <!--<router-link :to="{name:'novedades'}">-->
        <!--<button type="button" style="margin-top: 25px" :class="{'text-warning': $store.state.xNotificaciones}"-->
        <!--class="nc-icon pulsar navbar-toggle navbar-toggler-icon"><i class="far fa-bell"></i></button>-->
        <!--</router-link>-->
        <ul class="navbar-nav" >
          <drop-down position="right" v-if="!esSelfi">
            <template slot="title">
              <router-link :to="{ name: 'soporte-online' }">
                <i
                  :class="{ 'text-warning': numTicketPendientes > 0 }"
                  class="nc-icon nc-bell-55"
                  :title="
                    numTicketPendientes > 0
                      ? $t('tienesTicketsPendientesDeCerrar')
                      : ''
                  "
                ></i>
                <span
                  v-if="numTicketPendientes > 0"
                  class="notification"
                  
                  :title="$t('tienesTicketsPendientesDeCerrar')"
                  >{{ numTicketPendientes }}</span
                >
              </router-link>
            </template>
          </drop-down>
          <drop-down position="right" v-if="!esSelfi">
            <template slot="title">
              <router-link :to="{ name: 'novedades' }">
                <i
                  :class="{ 'text-warning': $store.state.xNotificaciones }"
                  class="nc-icon nc-notification-70"
                  
                ></i>
                <span
                  v-if="$store.state.xListNovedades > 0"
                  class="notification"
                  
                  >{{ $store.state.xListNovedades }}</span
                ><small >Novedades</small>
              </router-link>
            </template>
          </drop-down>
          <!--<router-link :to="{name:'novedades'}">-->
          <!--<button type="button" style="margin-top: 25px" :class="{'text-warning': $store.state.xNotificaciones}"-->
          <!--class="nc-icon pulsar navbar-toggle navbar-toggler-icon"><i class="far fa-bell"></i></button>-->
          <!--</router-link>-->
          <drop-down id="languageSelector" :menu="true" position="right" >
            <!--<i v-if="comprobarIdioma() == 'es'" slot="title"><country-flag country='es' size='small'/><span class="noselect" style="font-style: normal !important; color: black;">&nbsp; ES</span></i>-->
            <i slot="title" >
              <img
                v-if="this.$i18n.locale == 'cat'"
                src="static/img/catalanFlag.png"
                width="15"
              />
              <img
                v-else-if="this.$i18n.locale == 'eus'"
                src="static/img/euskalFlag.png"
                width="15"
              />
              <country-flag
                v-else
                :country="localeBandera(this.$i18n.locale)"
                size="small"
              />
              <span
                v-if="this.$i18n.locale == 'pt'"
                class="noselect"
                style="font-style: normal !important; color: black"
              >&nbsp; PT
              </span>
              <span
                v-if="this.$i18n.locale == 'es'"
                class="noselect"
                style="font-style: normal !important; color: black"
              >&nbsp; ES
              </span>
              <span
                v-if="this.$i18n.locale == 'cat'"
                class="noselect"
                style="font-style: normal !important; color: black"
              >&nbsp; CAT
              </span>
              <span
                v-if="this.$i18n.locale == 'en'"
                class="noselect"
                style="font-style: normal !important; color: black"
              >&nbsp; ENG
              </span>
              <span
                v-if="this.$i18n.locale == 'eus'"
                class="noselect"
                style="font-style: normal !important; color: black"
              >&nbsp; EUS
              </span>
            </i>
            <a
              type="button"
              class="dropdown-item"
              @click.prevent="verIdioma('es')"
            >
              <country-flag country="es" size="small" />  &nbsp;ES
            </a>
            <a
              type="button"
              class="dropdown-item"
              @click.prevent="verIdioma('en')"
            >
              <country-flag country="gb" size="small" />  &nbsp;EN
            </a>
            <a
              type="button"
              class="dropdown-item"
              @click.prevent="verIdioma('pt')"
            >
              <country-flag country="pt" size="small" />  &nbsp;PT
            </a>
            <a
              type="button"
              class="dropdown-item"
              @click.prevent="verIdioma('eus')"
            >
              <img src="static/img/euskalFlag.png" width="15" />  &nbsp;EUS
            </a>
            <a
              type="button"
              class="dropdown-item"
              @click.prevent="verIdioma('cat')"
            >
              <img src="static/img/catalanFlag.png" width="15" />  &nbsp;CAT
            </a>
          </drop-down>
          <drop-down :menu="true" position="right" >
            <i slot="title" class="nc-icon nc-bullet-list-67"></i>
            <!--<a class="dropdown-item" href="#">-->
            <!--<i class="nc-icon nc-email-85"></i> Soporte Online-->
            <!--</a>-->
            <!--<a class="dropdown-item" href="#">-->
            <!--<i class="nc-icon nc-settings-90"></i> Ajustes-->
            <!--</a>-->
            <!--<div class="divider"></div>-->

            <a href="#" class="dropdown-item" @click.prevent="perfil">
              <i class="nc-icon nc-circle-09"></i> {{ $t("perfil") }}
            </a>
            <a href="#" class="dropdown-item" @click.prevent="soporteSelfi" v-if="esSelfi">
              <i class="nc-icon nc-email-83"></i> {{ $t("soporteOnline") }}
            </a>

            <a
              href="#"
              class="dropdown-item text-danger"
              @click.prevent="logout"
            >
              <i class="nc-icon nc-button-power"></i> {{ $t("cerrarSesion") }}
            </a>

            <!--   <a href="#" class="dropdown-item " @click.prevent="permisos">
                               <i class="nc-icon nc-preferences-circle-rotate"></i> Permisos
                           </a>-->
          </drop-down>
        </ul>
      </div>
    </div>
  </nav>

</template>
<script>
import Vue from "vue";
import { mapMutations } from "vuex";
import swal from "sweetalert2";

export default {
  computed: {
    routeName() {
      // return "Versión BETA";
      return this.$store.getters.nameRoute;
    },
    premiumBackgroundStyle() {
      return {
        'background-color' : '#142330'
        //'background-image': 'url("static/img/sidebar-numier.jpg")',
      }
    }
  },
  

  created() {
    
    this.screen.width = screen.width;
    this.screen.height = screen.height;
    
    this.getNovedadesNoVistas();
    this.getTicketPendientesCerrar();
    this.comprobanteDeUpdate();
    this.checkIsSelfi();
   //this.activateBtnUpdateTPV();
  },
  data() {
    return {
      
      activeNotifications: false,
      
      novedades: false,
      listNovedades: 0,
      idioma: "",
      perfilUsuario: {
        nombre: "",
        apellidos: "",
        email: "",
        contrasenyaAntigua: "",
        contrasenyaNueva: "",
        contrasenyaConfirm: "",
      },
      screen: {
        width: "",
        height: "",
      },
      listTicketsPendientes: "",
      numTicketPendientes: 0,
      needsUpdate: false,
      nombresTPVaActualizar: "",
      esSelfi: false,
    };
  },
  methods: {
    ...mapMutations(["changeSectores", "changeListaSectores"]),
    localeBandera(codigo) {
      if (codigo == "en") {
        codigo = "gb";
      }
      return codigo;
    },


    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },



    openModal(){
      this.$modal.show("modal-premium");

    },
    closeModal(){
      this.$modal.hide("modal-premium");
    },

    novedadesRoute() {
      this.$router.push({ name: "novedades" });
    },
    getTicketPendientesCerrar() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "tickets/getTicketPendientesCerrar",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listTicketsPendientes =
              response.data.result.listTicketsPendientes;
            vm.numTicketPendientes =
              response.data.result.listTicketsPendientes.length;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getNovedadesNoVistas() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "novedades/getNovedadesByUser",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            if (response.data.result.novedadesNoVistas > 0) {
              vm.$store.commit("changeNotificaciones", true);
              vm.$store.commit(
                "changeListNovedades",
                response.data.result.novedadesNoVistas
              );

              vm.listNovedades = response.data.result;
              vm.novedades = true;
              if (response.data.result.mostrarNotificacion) {
                vm.$notify({
                  title: "Novedades Numier",
                  message:
                    "Tienes noticias sin leer (" +
                    response.data.result.novedadesNoVistas +
                    ")",
                  icon: "nc-icon nc-bell-55",

                  showClose: false,
                  offset: 100,
                  onClick: function() {
                    vm.novedadesRoute();
                  },
                  horizontalAlign: "right",
                  verticalAlign: "top",
                  type: "warning",
                });
              }
            } else {
              vm.$store.commit("changeNotificaciones", false);
            }
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    capitalizeFirstLetter(string) {
      return string.toUpperCase();
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    logout() {
      this.$store.dispatch("setJWT", "");
      this.$store.dispatch("setBusiness", "");
      this.$store.dispatch("setDateTo", "");
      this.$store.dispatch("setDateFrom", "");

      this.$cookie.delete("jwt");

      if (Vue.$cookies.isKey("sectores")) {
        this.changeSectores(false);
        this.changeListaSectores([]);
        Vue.$cookies.remove("sectores");
        Vue.$cookies.remove("filtroSector");
      }

      Vue.$cookies.remove("language");

      this.$router.push("/login");
    },
    permisos() {
      this.$router.push("/permisos");
    },

    perfil() {
      this.$router.push("/perfil");
    },

    soporteSelfi(){
      this.$router.push("/soporte-online");
    },

    isPremium() {
      return this.$store.state.xuser.isPremium == "1"
    },
    idTecnicoAsignado() {
      return this.$store.state.xuser.idTecnicoAsignado;
    },
    nameTecnicoAsignado() {
      return this.$store.state.xuser.nameTecnico;
    },
    photoTecnicoAsignado() {
      return this.$store.state.xuser.photoTecnico;
    },
    verIdioma(idioma) {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt,
        idioma: idioma,
      };

      let vm = this;
      this.axios
        .post(
          this.$store.getters.apiUrl + "general/editLanguageByUser",
          params,
          config
        )
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            Vue.$cookies.remove("language");
            Vue.$cookies.set("language", idioma, Infinity);
            vm.$forceUpdate();
            window.location.reload();
          } else {
            console.error(response.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },
    comprobanteDeUpdate(){
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "tpvs/getTpvaActulizar",
          config
        )
        .then(function(response) {
          //console.log("respuesta de updateTPVS"+response.data.result)
          
          if (response.data.response) {
            if (response.data.result.confirmacion) {
              vm.nombresTPVaActualizar=response.data.result.listaNombresTpvs;
              vm.activateBtnUpdateTPV();
            } 
          }
          
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    activateBtnUpdateTPV(){
      //console.log("boton updateTPV activado")
      
      this.needsUpdate = true;
    },
    desactivateBtnUpdateTPV(){
      //console.log("boton updateTPV desactivado")
      
      this.needsUpdate = false;
    },
    informacionTicketsUpdateTPV(){
      let vm = this;
      
    swal({
         title: 'Solicitud de actualización',
         text: "Hay actualizaciones disponibles para: "+this.nombresTPVaActualizar,
         showCancelButton: true,
         confirmButtonClass: 'btn btn-success btn-fill',
         cancelButtonClass: 'btn btn-danger btn-fill',
         confirmButtonText: 'Solicitar',
         cancelButtonText: 'Cancelar',
         buttonsStyling: true
    }).then((result) => {
        if (result.value) {
            vm.notificarTicketsUpdateTPV();    
         }
    });
  },
    notificarTicketsUpdateTPV(){
      
    var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        jwt: this.$store.getters.jwt
      };
      let vm = this;
      this.axios
      //llamada api tickets solicitud de update
        .post(
          this.$store.getters.apiUrl + "tickets/setTicketsTpvsaActualizar",
          params,
          config
        )
        .then(function(response) {
          //console.log("respuesta de updateTPVS"+response.data.response)
          
          if (response.data.response) {
            vm.desactivateBtnUpdateTPV();
             vm.$notify({
                message:
                vm.$t("Ticket") +
                " enviado " +
                vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
            });
          }else{
             swal({
                    title: vm.$t("atencion"),
                    text: "No se ha podido enviar su ticket",
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
   
    },
  },
};
</script>
<style>

.pulsar {
  color: #999;
}

.pulsar:hover {
  color: #333;
}

.navbar .navbar-nav .dropdown-toggle:after {
  display: none;
}

#languageSelector .dropdown-menu {
  min-width: 1rem !important;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
@media only screen and (max-width: 992px) {
  .noti {
    width: 25% !important;
  }
}

.notificationCircle {
  height: 15px;
  width: 15px;
  line-height: 15px;
  border-radius: 50%;
  color: #fff;
  background-color: rgb(196, 0, 0);
  text-align: center;
}

.mobile-noti-number {
  color: white;
  background-color: #e13131;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  line-height: 25px;
}
.modal-backdrop
{
    opacity:0.5 !important;
}

.fullscreen-modal .modal-dialog {
  margin: 0;
  margin-right: auto;
  margin-left: auto;
  margin-top: 0;
  width: 100%;
}


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/TopNavbar.vue